var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 5C16.667 4.07953 15.9205 3.33301 15 3.33301C14.0795 3.33301 13.333 4.07953 13.333 5C13.333 5.92047 14.0795 6.66699 15 6.66699C15.9205 6.66699 16.667 5.92047 16.667 5ZM3.33301 15C3.33301 15.9205 4.07953 16.667 5 16.667C5.92047 16.667 6.66699 15.9205 6.66699 15C6.66699 14.0795 5.92047 13.333 5 13.333C4.07953 13.333 3.33301 14.0795 3.33301 15ZM18.333 5C18.333 6.56546 17.2538 7.87732 15.7988 8.23535C15.627 10.1759 14.7811 12.0041 13.3926 13.3926C12.0041 14.7811 10.1759 15.627 8.23535 15.7988C7.87732 17.2538 6.56546 18.333 5 18.333C3.15905 18.333 1.66699 16.8409 1.66699 15C1.66699 13.4467 2.72912 12.1414 4.16699 11.7715V2.5C4.16699 2.03976 4.53976 1.66699 5 1.66699C5.46024 1.66699 5.83301 2.03976 5.83301 2.5V11.7715C6.99085 12.0694 7.90454 12.974 8.2168 14.126C9.72124 13.9633 11.1338 13.2939 12.2139 12.2139C13.2939 11.1338 13.9633 9.72124 14.126 8.2168C12.7091 7.83274 11.667 6.53844 11.667 5C11.667 3.15905 13.1591 1.66699 15 1.66699C16.8409 1.66699 18.333 3.15905 18.333 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.d834dece6b164b99cd4033e3bb878ec1.svg";
export { ForwardRef as ReactComponent };